var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8693_20520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8693_20520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9601 13.6666C11.7038 13.6666 10.4416 13.3745 9.17358 12.7903C7.9057 12.2061 6.74075 11.382 5.67875 10.318C4.61686 9.25387 3.79381 8.08887 3.20959 6.82298C2.62536 5.5572 2.33325 4.29615 2.33325 3.03981C2.33325 2.83792 2.39992 2.6697 2.53325 2.53515C2.66659 2.40059 2.83325 2.33331 3.03325 2.33331H5.20759C5.37592 2.33331 5.52442 2.38826 5.65309 2.49815C5.78175 2.60792 5.86359 2.74359 5.89859 2.90515L6.28075 4.86665C6.3072 5.04865 6.30164 5.20504 6.26409 5.33581C6.22642 5.46659 6.15886 5.57642 6.06142 5.66531L4.52175 7.16415C4.76953 7.61792 5.05264 8.0472 5.37108 8.45198C5.68942 8.85665 6.03409 9.24315 6.40509 9.61148C6.77086 9.97737 7.15975 10.3171 7.57175 10.6308C7.98375 10.9445 8.42864 11.2364 8.90642 11.5065L10.4024 9.99748C10.5068 9.88892 10.6331 9.81281 10.7814 9.76915C10.9296 9.72559 11.0837 9.71492 11.2436 9.73715L13.0948 10.1141C13.2631 10.1586 13.4005 10.2445 13.5069 10.3718C13.6134 10.4991 13.6666 10.6436 13.6666 10.8051V12.9666C13.6666 13.1666 13.5993 13.3333 13.4648 13.4666C13.3302 13.6 13.162 13.6666 12.9601 13.6666ZM4.04859 6.21798L5.23842 5.07948C5.25975 5.06237 5.27364 5.03887 5.28009 5.00898C5.28653 4.97909 5.28547 4.95131 5.27692 4.92565L4.98709 3.43581C4.97853 3.4017 4.96359 3.37609 4.94225 3.35898C4.92092 3.34187 4.89314 3.33331 4.85892 3.33331H3.43325C3.40759 3.33331 3.3862 3.34187 3.36909 3.35898C3.35209 3.37609 3.34359 3.39748 3.34359 3.42315C3.3777 3.8787 3.45225 4.34148 3.56725 4.81148C3.68214 5.28159 3.84259 5.75042 4.04859 6.21798ZM9.84858 11.9795C10.2905 12.1855 10.7514 12.343 11.2313 12.452C11.7113 12.5609 12.1598 12.6256 12.5768 12.6461C12.6024 12.6461 12.6238 12.6376 12.6409 12.6205C12.658 12.6034 12.6666 12.582 12.6666 12.5563V11.1538C12.6666 11.1196 12.658 11.0918 12.6409 11.0705C12.6238 11.0491 12.5982 11.0342 12.5641 11.0256L11.1641 10.741C11.1384 10.7324 11.116 10.7314 11.0968 10.7378C11.0775 10.7443 11.0572 10.7581 11.0358 10.7795L9.84858 11.9795Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.57f2615cef76bb08694ac0e18cbbf4d6.svg";
export { ForwardRef as ReactComponent };